/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentGraphEdge = zod.object({
  carbonCopy: zod.boolean(),
  certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']),
  creator: zod.object({
    principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER', 'SYSTEM', 'AGENT']),
    scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
    uuid: zod.uuid().describe('UUID v4 identifier'),
  }),
  edgeDescription: zod
    .string()
    .nullable()
    .describe('Authored edge text, returned verbatim including an explicit empty string.'),
  edgeKey: zod
    .string()
    .nullable()
    .describe(
      'Schema slot key on a TYPE→TYPE declaration; null on an ordinary relationship. An empty string is a stored value, not an absence.',
    ),
  edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
  fromLineageUuid: zod.uuid().describe('UUID v4 identifier'),
  fromUuid: zod.uuid().describe('UUID v4 identifier'),
  maxCount: zod.int().nullable(),
  minCount: zod.int().nullable(),
  position: zod.int().nullable(),
  toLineageUuid: zod.uuid().describe('UUID v4 identifier'),
  toUuid: zod.uuid().describe('UUID v4 identifier'),
});

export type ContentGraphEdge = zod.input<typeof ContentGraphEdge>;
export type ContentGraphEdgeOutput = zod.output<typeof ContentGraphEdge>;
